/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
  $(document).ready(function() {
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("You must agree with the terms and conditions of sales to check out.");
        return false;
      }
    });
  });

var sections = window.theme.sections;
var slideshowAutoExtension = {
  init: function() {
    this.on('slideshow_desktop_init_done', this._autoplaySlideshow.bind(this));
  },
  _autoplaySlideshow: setInterval(function() {
    var $slide = $('.slideshow__slide--active')
                   .removeClass('slideshow__slide--active');

   /* var $button = $('.slideshow__button--active')
                   .removeClass('slideshow__button--active');*/

    var $slides = $('.slideshow__slide');

    var currentIndex = ($slides.index($slide)+1) % $slides.length;

    $slides
      .eq(currentIndex)
      .addClass('slideshow__slide--active');

    /*var $buttons = $('.slideshow__button')
      .eq(currentIndex)
      .addClass('slideshow__button--active');*/

  }, 2000)

};

sections.extend('slideshow', slideshowAutoExtension);